import { type I18nLocale, t } from '@ardoq/i18n';

export const AI_SUGGESTED_OPTION_ID = 'ai-suggestion-option';

export const getDefaultResultsPageButtonText = (i18nLocale: I18nLocale) =>
  t(
    i18nLocale,
    'surveysUi:consts.defaultResultsPageButtonText',
    'Existing entries'
  );
